import { injectCpmsBoUserMeApi } from '@delmonicos/shared-sdk/libs/cpms/src/clients/redux/cpms-bo-user-me.service';

import { baseApi } from '@service/base-api.service';

export const cpmsBoUserMeApi = injectCpmsBoUserMeApi(baseApi);

export const {
  useCpmsBoGetMeQuery,
  useCpmsBoUpdatePasswordMutation,
  useCpmsBoUpdatePreferencesMutation,
} = cpmsBoUserMeApi;
